import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'vui-autocomplete-input-dropdown',
    templateUrl: './autocomplete-input-dropdown.component.html',
    styleUrls: ['./autocomplete-input-dropdown.component.scss']
})
export class AutocompleteInputDropdownComponent {
    @HostBinding('class.opened') @Input() public opened: boolean;
}
